<template>
	<div :class="'custom-message ' + (isMine ? 'my-custom' : '')" @click="openMap">
		<div class="map-title">
			<div class="map-name">
				<span class="flex1">位置：</span>
			</div>
		</div>
		<div class="map-text">
			{{renderDom.name}}
		</div>
	</div>
</template>

<script>

export default {
	data() {
		return {
			renderDom: {},
		};
	},

	components: {},
	props: {
		message: {
			type: Object,
			default: ''
		},
		isMine: {
			type: Boolean,
			default: true
		}
	},
	watch: {
		message: {
			handler: function(newVal){
				let addr ={}
				const content =newVal._elements[0].content
				addr.name = content.description
				addr.latitude = content.latitude
				addr.longitude = content.longitude
				this.renderDom = addr
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		openMap(){
			uni.openLocation({
						latitude: this.renderDom.latitude,
						longitude: this.renderDom.longitude,
						name:this.renderDom.name,
						success: function () {

						}
					});
		}
	}
};
</script>
<style>
.custom-message {
	background-color: rgb(241, 239, 239);
	border-radius: 2px 10px 10px 10px;
	padding: 10px;
}

.my-custom {
	border-radius: 10px 2px 10px 10px;
}
.map-title{
	display: flex;
	align-items: center;
	justify-content: space-between;
}
	
.map-name{
	display: flex;
	align-items: center;
	font-size: 12px;
	line-height: 2;
}
.flex1{
	flex: 1;
}
.map-gray{
	color: #999;
	font-size: 26px;
}
.map-img{
	width:50px;
	height: 50px;
}

.map-text{
	width:440px;
	color: #666;
	/* overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap; */
	font-size: 14px;
}

</style>
